<!--
    描述：银行列表页面
    Created by asq
-->
<template>
	<div class="operation-layout">
		<div v-if="searchToggle">
			<div class="search">
				<el-form :model="searchForm"
						 label-width="130px">
					<el-row>
						<el-col :span="6">
							<el-form-item label="银行ID：">
								<el-input :placeholder="'请输入'"
										  clearable
										  v-model="searchForm.id"
										  size="small">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="银行名称：">
								<el-input :placeholder="'请输入'"
										  clearable
										  v-model="searchForm.sname"
										  size="small">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="5"
								class="mt4 ml10">
							<el-button type="primary"
									   class="btn-blue"
									   size="small"
									   @click="searchResult">搜索</el-button>
							<el-button type="warning"
									   size="small"
									   @click="resetSerach">重置</el-button>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
		<div class="operation-main">
			<div class="operation-header">
				<div class="title">
					合计开票： <span class="blue">{{ total }}</span> 张
				</div>
				<div class="mt10 mb10 fr">
					<el-button type="primary"
							   class="btn-blue"
							   size="small"
							   @click="changeState">
						筛选
						<i v-if="searchToggle"
						   class="el-icon-caret-bottom ml5"></i>
						<i v-else
						   class="el-icon-caret-top ml5"></i>
					</el-button>
					<el-button size="small"
							   class="btn-blue"
							   icon="el-icon-refresh"
							   type="primary"
							   @click="refresh"></el-button>
				</div>

			</div>
			<div class="operation-container w-table-layout w-table-page">
				<div class="w-table-content"
					 v-show="tableShow">
					<el-table ref="xTable"
							  :data="filterData"
							  height="100%"
							  highlight-current-row
							  border>
						<el-table-column type="index"
										 label="序号"
										 align="center"
										 width="80"></el-table-column>
						<el-table-column prop="id"
										 label="银行ID"
										 align="center"
										 width="160"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="sname"
										 label="银行名称"
										 align="center"
										 width="180"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="account"
										 label="银行账户(保证金母账户)"
										 align="center"
										 width="180"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="companyName"
										 label="企业名称"
										 align="center"
										 width="180"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="creditCode"
										 label="统一社会信用代码"
										 align="center"
										 width="180"
										 show-overflow-tooltip>

						</el-table-column>
						<el-table-column prop="busToken"
										 label="业务令牌（key)值"
										 align="center"
										 width="180"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="createDate"
										 label="创建日期"
										 align="center"
										 min-width="100"
										 show-overflow-tooltip></el-table-column>
						<el-table-column prop="buttFlag"
										 label="是否完成对接"
										 align="center"
										 width="120"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="scope.row.buttFlag == 0">否</span>
								<span v-else-if="scope.row.buttFlag == 1">是</span>
							</template></el-table-column>
						<el-table-column prop="isFlag"
										 label="对接启用状态"
										 align="center"
										 width="120"
										 show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="status">
									<el-switch class="switch"
											   v-model="scope.row.isFlag"
											   active-color="#2671cc"
											   inactive-color="#ddd"
											   active-text="启用"
											   inactive-text="关闭"
											   :active-value="1"
											   :inactive-value="0"
											   :class="{ opacityHide: !roleBtns.includes('bank-enable') }"
											   @click.native.prevent="isFlagChange(scope.row)">
									</el-switch>
								</div>
							</template></el-table-column>

						<el-table-column align="center"
										 width="100">
							<template slot="header">操作</template>
							<template slot-scope="scope">
								——
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="currentPage"
								   :page-sizes="pageList"
								   :page-size="pageSize"
								   :total="total"
								   layout="total, sizes, prev, pager, next, jumper">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template> 

<script>
import { getBankList, setBankStatus } from 'api/modules/bank'
import { mapState } from 'vuex'
import { dateFormat } from 'utils/tools'
export default {
	name: 'Bank-list',
	components: {},
	data() {
		return {
			filterData: [
				{
					createDate: '大富翁银行'
				}
			],
			searchForm: {
				id: '',
				sname: ''
			},
			loading: false,
			//筛选框
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			searchToggle: true,
			tableShow: true
		}
	},

	created() {
		this.getData()
	},
	methods: {
		//重置筛选框
		resetSerach() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		refresh() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm = {}
			this.getData()
		},

		//获得列表数据
		getData() {
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			getBankList(params)
				.then(res => {
					this.loading = false
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
					// 设置回显
					this.setChecked()
				})
				.catch(err => {
					this.loading = false
				})
		},

		// 点击切换状态
		isFlagChange(row) {
			if (this.roleBtns.includes('bank-enable')) {
				this.$confirm('是否确认改变启用状态?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						// row.isFlag == 0 ? (row.isFlag = 1) : (row.isFlag = 0)
						let param = { id: row.id, isFlag: row.isFlag }
						setBankStatus(param).then(res => {
							if (res.operationCode == 1) {
								this.$message.success('修改成功')
								this.getData()
							}
						})
					})
					.catch(() => {
						row.isFlag == 0 ? (row.isFlag = 1) : (row.isFlag = 0)
						this.$message.info('操作取消')
					})
			}
		},

		//筛选框重置
		handleClose() {
			this.dialogObj.visible = false
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 搜索
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		}
	},

	computed: {
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout {
	padding: 0 8px;
	.search {
		border-bottom: 1px solid #2672cc;
		padding: 5px 0;
	}
	.mt4 {
		margin-top: 4px;
	}
}
</style>
<style lang="less">
.status {
	.switch > .el-switch__label--right > span {
		margin-left: 0 !important;
		margin-right: 15px !important;
	}
}
</style>
